import { useState } from 'react'
import type { Me } from '../api'
import { ApiError } from '../api'
import type { LicenseConfig } from '../shop'
import { shop } from '../shop'

type Props = {
  assetIds: number[]
  assetLabel: string
  config: LicenseConfig | null
  summary: string[]
  me: Me | undefined
  onClose?: () => void
}

/** Contact form for licenses the configurator can't express. */
export function InquiryForm({ assetIds, assetLabel, config, summary, me, onClose }: Props) {
  const [f, setF] = useState({
    name: me?.authenticated ? me.name ?? '' : '', email: me?.email ?? '', organisation: '', phone: '',
    usage: summary.length ? `${summary.join('\n')}\n\nAbweichend / zusätzlich: ` : '', message: '', website: '',
  })
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const set = (k: keyof typeof f) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setF({ ...f, [k]: e.target.value })

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await shop.inquiry({ ...f, asset_ids: assetIds, config })
      setDone(true)
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Die Anfrage konnte nicht gesendet werden.')
    } finally {
      setBusy(false)
    }
  }

  if (done) {
    return (
      <div className="inq done" role="status">
        <h2>Danke – Ihre Anfrage ist angekommen.</h2>
        <p>Wir melden uns so bald wie möglich bei {f.email}. Eine Kopie Ihrer Angaben haben wir Ihnen per E-Mail geschickt.</p>
      </div>
    )
  }

  return (
    <form className="inq" onSubmit={submit}>
      <div className="inq-head">
        <h2>Individuelle Lizenz anfragen</h2>
        {onClose && <button type="button" className="linkbtn" onClick={onClose}>schließen</button>}
      </div>
      {assetLabel && <p className="muted small">Bild: {assetLabel}</p>}
      <div className="fgrid">
        <label>Name *<input value={f.name} onChange={set('name')} required autoComplete="name" /></label>
        <label>E-Mail *<input type="email" value={f.email} onChange={set('email')} required autoComplete="email" /></label>
        <label>Organisation<input value={f.organisation} onChange={set('organisation')} autoComplete="organization" /></label>
        <label>Telefon<input value={f.phone} onChange={set('phone')} autoComplete="tel" /></label>
        <label className="span2">Gewünschte Nutzung *
          <textarea rows={5} value={f.usage} onChange={set('usage')} required
            placeholder="Medium, Auflage oder Reichweite, Größe, Laufzeit, Gebiet, Sprache, Exklusivität …" />
        </label>
        <label className="span2">Nachricht<textarea rows={3} value={f.message} onChange={set('message')} /></label>
        <label className="hp" aria-hidden="true">Website<input tabIndex={-1} value={f.website} onChange={set('website')} autoComplete="off" /></label>
      </div>
      {error && <p className="err" role="alert">{error}</p>}
      <div className="row2">
        <span className="muted small">Wir nutzen Ihre Angaben nur zur Bearbeitung der Anfrage.</span>
        <button className="btn primary" disabled={busy}>{busy ? 'Senden …' : 'Anfrage senden'}</button>
      </div>
    </form>
  )
}
